// extracted by mini-css-extract-plugin
module.exports = {"header":"_1aPmZlaJ","title":"CHurL0ev","closeButton":"_2uH78ZmT"};